/* importMetadata.component.js */

import importMetadataController from "./importMetadata.controller";

/**
 * @desc component for importing Source Metadata for Data Mapping tab when creating or editing a custom product
 * @example <import-metadata></import-metadata>
 */

const importMetadata = {
    bindings: {
        product: '<',
        updateHiddenSteps: '<',
        saveStep: '<',
        isCreate: '<'
    },
    controller: importMetadataController,
    controllerAs: 'imvm',
    templateUrl: '/App/Components/Connections/CustomProductConnection/DataMapping/ImportMetadata/importMetadata.tmpl.html'
};

export default importMetadata;